import { render, staticRenderFns } from "./formHeader.vue?vue&type=template&id=68ea714a&"
import script from "./formHeader.vue?vue&type=script&lang=js&"
export * from "./formHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports